import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { t } from '../../../components/common/Translate';
import { Record } from '../../../config/Record/RecordEntity';
import { Auth, formManager, recordActions } from '../../../config/configuration/react';
import { useForm } from '../../../Store/uses/useForm';
import saveReferentials from '../../../services/Auth/saveReferentials';

export const useActionButton = (recordId, formId, label) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { setFormId, formEntity, getForm } = useForm(formId);
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const recordEntity = new Record(record);
  const currentTab = useSelector((state) => state.reduxRecords?.currentTab);
  const [isLoading, setIsLoading] = useState(false);
  const source = useSelector((state) => state.reduxRecords.data[recordId])?.sourceInfos;
  const brands = useSelector((state) => state.reduxRecords.data[recordId])?.carcheckPointOfSale?.brands || [];
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isNrmFile, setIsNrmFile] = useState();
  const [disableBtn, setDisableBtn] = useState();
  const [isCarcheckFile, setIsCarcheckFile] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const userBrands = Auth.brandIds() || [];
  const possibleBrands = brands.filter((b) => userBrands.indexOf(b.id) !== -1);
  const referentialLabels =
    recordEntity.isNrmRecord() && source?.brand?.referentials?.length > 0
      ? source.brand.referentials.map((rf) => rf.label)
      : source?.sourceGroupData?.referentialLabels;
  const [isChecked, setIsChecked] = useState(false);
  const isBEUser = Auth.country() === 'BE';
  const isEasyReprise = record?.carcheckPointOfSale?.source === 'Easyreprise';
  const grayCardDate = useSelector((state) => state.reduxRecords.data[recordId]?.vehicle?.gcDate?.date);
  const addGrayCardDate =
    recordEntity.status() === 1 &&
    ['PT', 'ES'].includes(recordEntity.getCountry()) &&
    recordEntity.isAutobizMarket() &&
    !grayCardDate;

  const goToVehicleIdentify = () => {
    if (!recordEntity.displayVehicleIsAllowed()) return;
    history.push({
      pathname: `/files/${recordId}/identification`,
      state: {
        ...history.location.state,
      },
    });
  };

  useEffect(() => {
    if (currentTab !== 'pricing_title') dispatch(recordActions.changeCurrentTab('pricing_title'));
  }, []);

  let action = null;
  let nextAction = recordEntity.nextAction(label);
  const showRefreshCta =
    !formEntity.checkUpdatedAtInspection() &&
    recordEntity.isHBS() &&
    recordEntity.status() === 2 &&
    recordEntity.type() === 1;
  nextAction = recordEntity.status() === 7 && recordEntity.isNrmRecord() ? null : nextAction;
  useEffect(() => {
    setFormId(formId);
  }, [formId]);

  const goToIdentification = (newRecordId) => {
    history.push({
      pathname: `/files/${newRecordId}/identification`,
      state: {
        from: `/files/${newRecordId}`,
        ...history.location.state,
      },
    });
  };

  const toggle = () => setIsOpen((prev) => !prev);
  const createRecord = () => {
    if (isOpen) setIsOpen(false);
    if (selectedLanguage) _.set(record, 'record.pdfLanguage', selectedLanguage);
    if (selectedBrand) _.set(record, 'record.brandFileId', selectedBrand);
    if (isChecked) _.set(record, 'record.gdprClientInformed', true);
    dispatch(recordActions.updateAppointmentLocally(record));
    dispatch(recordActions.createRecord(goToIdentification));
  };

  const checkDisplayModal = (origin) => {
    let checkModal = isEasyReprise;
    setIsCarcheckFile(true);
    setIsChecked(false);
    setDisableBtn(true);
    setIsNrmFile(false);
    if (possibleBrands.length > 1 || isBEUser) {
      setErrorMessage('');
    }
    if (['nrm', 'hbs.nrm', 'nrm.smart', 'nrm.sol', 'nrm.sol.hbs'].includes(origin)) {
      setIsNrmFile(true);
      setIsCarcheckFile(false);
      setSelectedBrand(null);
      checkModal = true;
    }
    return checkModal ? toggle() : createRecord();
  };

  const initialize = (recordTypeId = 1, origin = 'carcheck') => {
    _.set(record, 'record.recordTypeId', recordTypeId);
    _.set(record, 'record.origin', origin);
    if (possibleBrands.length === 1) {
      setErrorMessage('');
      _.set(record, 'record.brandFileId', possibleBrands?.[0]?.id);
    }
    checkDisplayModal(origin);
  };

  const identification = () => {
    goToIdentification(recordId);
  };

  const continueInspection = (newFormId) => {
    history.push({
      pathname: `/forms/${newFormId}`,
      state: {
        from: `/files/${recordId}`,
        queries: `/files/${recordId}`,
        ...history.location.state,
      },
    });
  };

  const saveAndContinue = async (newFormId) => {
    setIsLoading(true);
    await formManager.saveFormInLocal(newFormId);
    setIsLoading(false);
    continueInspection(newFormId);
  };

  const launchInspection = () => {
    let profile;
    if (nextAction === 'light_form') {
      profile = 'b2b';
    } else if (nextAction === 'full_form') {
      profile = 'b2c';
    } else {
      profile = record?.counterInspection?.profile || null;
    }
    saveReferentials(referentialLabels, Auth.token(), nextAction, source?.name);
    dispatch(recordActions.launchInspection(saveAndContinue, profile));
  };

  const onChangeBtn = () => {
    setIsChecked(!isChecked);
    if (Number(selectedBrand) || possibleBrands.length === 1 || isCarcheckFile) setDisableBtn(!disableBtn);
  };
  const onChangeBrand = (e) => {
    setSelectedBrand(e.target.value);
    if (Number(e.target.value) && isChecked) setDisableBtn(false);
    else setDisableBtn(true);
  };

  const refreshForm = async (newFormId) => {
    setIsLoading(true);
    await formManager.saveFormInLocal(newFormId);
    await getForm();
    setIsLoading(false);
  };

  const actions = {
    initialize: () => initialize(),
    reactivateRecord: () => dispatch(recordActions.reactivateRecord()),
    launchInspection,
    light_form: () => launchInspection(),
    full_form: () => launchInspection(),
    continueInspection: () => continueInspection(formId),
    identification,
    refreshInspection: () => refreshForm(formId),
  };

  if (showRefreshCta) nextAction = 'refreshInspection';
  if (nextAction) action = actions[nextAction];

  let ctaContreInsp = false;
  if (Auth.isShowCtaContreInsp() && nextAction === 'initialize') {
    ctaContreInsp = {};
    ctaContreInsp.title = t('counterAppraisal');
    ctaContreInsp.action = () => initialize(2);
  }

  let ctaNrm = false;
  if (Auth.isNrmUser() && nextAction === 'initialize') {
    ctaNrm = {};
    ctaNrm.title = t('createNrmFile');
    let origin;
    if (Auth.isSmartContract()) {
      origin = 'nrm.smart';
    } else if (Auth.isSolContract()) {
      origin = 'nrm.sol';
    } else {
      origin = 'nrm';
    }
    ctaNrm.action = () =>
      possibleBrands.length === 0 ? setErrorMessage('errorMessageMissingBrandId') : initialize(1, origin);
  }

  return {
    isLoading,
    action,
    buttonTitle: t(nextAction),
    error: '',
    isError: false,
    ctaContreInsp,
    ctaNrm,
    formEntity,
    showRefreshCta,
    nextAction,
    isOpen,
    setIsOpen,
    toggle,
    possibleBrands,
    setSelectedBrand,
    setSelectedLanguage,
    onChangeBtn,
    onChangeBrand,
    disableBtn,
    createRecord,
    isChecked,
    isNrmFile,
    isBEUser,
    errorMessage,
    setErrorMessage,
    addGrayCardDate,
    goToVehicleIdentify,
  };
};

// if (status === 0) record.id = await createRecord();

// we create the record on server if user identify vehicle or modify appointments values
// const createRecord = async () => {
//   const query = {};
//   query.appointmentDateTime = data.appointment.appointmentDateTime;
//   query.concessionId = data.carcheckPointOfSale.id;
//   query.refHexaId = data.record.refHexaId;
//   query.refId = parseInt(data.record.refHexaId, 16);
//   query.status = 18;
//   const recordCreated = await postRecord(query, source.source);
//   return recordCreated.recordId;
// };
